import {useState} from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ListGroup from "react-bootstrap/ListGroup";
import AddBookModal from "./AddBookModal";

export const Tours = ({ toursData, appointment,setAppointment}) => {
  const [show, setShow] = useState(false);
  const [selectedtourName,setSelectedTourName]=useState("")

 
  const handleClick = (tourName) =>{
    setShow(true);
    setSelectedTourName(tourName)
  } 
 

  return (
   
    <Container className="p-2">
      <h3 className="display-6 fw-bold" style={{ color: "rgb(166,18,189)" }}>
        Our Tours
      </h3>
      <Row className="justify-content-center ">
        {toursData.map((item) => {
          return (
            <Col xs={12} sm={6} md={4} lg={3}>
              <img
                src={item.image}
                alt={item.tur_adi}
                className="img-thumbnail tour-img"
                onClick={()=>handleClick(item.tur_adi)}
                // width="300px"
               
              />
              <h5>{item.tur_adi}</h5>
              <ListGroup className="mb-4">
                <ListGroup.Item>{item.ozellikler} </ListGroup.Item>
              </ListGroup>
            </Col>
          );
        })}
      </Row>
      <AddBookModal 
       show={show}
       handleClose={()=>setShow(false)}
       tourName={selectedtourName}
       appointment={appointment}
       setAppointment={setAppointment}
       
       />
    </Container>   
  );    
};
